import { HorizontalSafeAreaContainer } from '../../../components';
import { useHorizontalSafeAreaHeaderOptions } from '../../../hooks';
import { ReorderActiveBagWarningScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  useHorizontalSafeAreaHeaderOptions();

  return (
    <HorizontalSafeAreaContainer>
      <ReorderActiveBagWarningScreen />
    </HorizontalSafeAreaContainer>
  );
}
